<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="salesContact?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + salesContact?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="salesContact?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${salesContact?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!salesContact?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ salesContact?.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ salesContact?.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ salesContact?.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ salesContact?.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${salesContact?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">MASTER SALES CONTRACT</h2>
                      </div>
                    </td>
                  </tr>
                  

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td colspan="100%">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>Invoice Date</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ formattedDate(salesContact?.invoice_date) }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Buyer Name</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ salesContact?.buyer.company_name }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Address</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ salesContact?.buyer.company_address }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Season</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ salesContact?.season }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>Invoice Number</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ salesContact?.invoice_no }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Sales Contract No</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ salesContact?.code }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Master Sales Contract No</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ salesContact?.contact_no }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Purchase Order (PO) NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ salesContact?.purchase_order_no || '-' }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: -25px;">
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 70px;">
                              <strong>SUPPLIER / BENEFICIARY:</strong><br/>
                              <strong>Name:</strong> {{ salesContact?.branch?.company?.name || '-' }}<br/>
                              <strong>Address:</strong> {{ salesContact?.branch?.company?.address || '-' }}<br/>
                              <strong>Email:</strong> {{ salesContact?.branch?.company?.email || '-' }}<br/>
                              <strong>Phone:</strong> {{ salesContact?.branch?.company?.mobile || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 70px;">
                              <strong>BUYER NAME AND ADDRESS:</strong><br/>
                              <strong>Name:</strong> {{ salesContact?.buyer.company_name || '-' }}<br/>
                              <strong>Address:</strong> {{ salesContact?.buyer.company_address || '-' }}<br/>
                              <strong>Email:</strong>  {{ salesContact?.buyer.company_email || '-' }}<br/>
                              <strong>Mobile:</strong>  {{ salesContact?.buyer.company_mobile || '-' }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: -15px; margin-bottom: -25px;">
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 100px;">
                              <strong>SUPPLIER / BENEFICIARY BANK DETAILS:</strong><br/>
                              <strong>Bank Name:</strong>  {{ salesContact?.beneficiary_bank.name || "-" }} <br/>
                              <strong>Bank Address:</strong>  {{ salesContact?.beneficiary_bank.address || "-" }} <br/>
                              <strong>Branch:</strong>  {{ salesContact?.beneficiary_bank.branch || "-" }} <br/>
                              <strong>Swift Code: </strong> {{ salesContact?.beneficiary_bank.swift_code || "-" }} <br/>
                              <strong>A/C No:</strong>  {{ salesContact?.beneficiary_bank.account_no || "-" }} <br/>
                              <strong>A/C Name:</strong>  {{ salesContact?.beneficiary_bank.account_name || "-" }} <br/>
                              <strong>Routing No:</strong>  {{ salesContact?.beneficiary_bank.routing_no || "-" }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 100px;">
                              <strong>BUYER'S BANK DETAILS:</strong><br/>
                              <strong>Bank Name:</strong>
                              {{ salesContact?.buyer?.bank_info?.[0]?.bank_name || "-" }} <br/>
                              <strong>Bank Address:</strong>
                              {{ salesContact?.buyer?.bank_info?.[0]?.branch_name || "-" }} <br/>
                              <strong>Branch:</strong>
                              {{ salesContact?.buyer?.bank_info?.[0]?.branch_name || "-" }} <br/>
                              <strong>Swift Code:</strong>
                              {{ salesContact?.buyer?.bank_info?.[0]?.swift_code || "-" }} <br/>
                              <strong>A/C No:</strong>
                              {{ salesContact?.buyer?.bank_info?.[0]?.ac_number || "-" }} <br/>
                              <strong>A/C Name:</strong>
                              {{ salesContact?.buyer?.bank_info?.[0]?.account_holder_name || "-" }} <br/>
                              <strong>Routing No:</strong>
                              {{ salesContact?.buyer?.bank_info?.[0]?.routing_number || "-" }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Details table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table mt-5" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">PO NUMBER</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">STYLE NUMBER</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">DESCRIPTION</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">HS CODE</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">COMPOSITION</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">COLOR NAME</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">SIZE RANGE</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">QUANTITY</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">UNIT PRICE</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">CURRENCY</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">TOTAL AMOUNT</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">EX-Factory</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">ETD</th>
                            <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">DESTINATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in salesContact?.details" :key="row.id">
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.po }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.style_no }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.description }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.hs_code }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.composition }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.color_name }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.size_range }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ (row.quantity) }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ formatNumber(row.unit_price) }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.currency?.name }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ (row.total_amount) }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ formattedDate(row.ex_factory_date) }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ formattedDate(row.etd_date) }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.destination }}</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;">Total</td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;">{{ salesContact?.total_quantity }}</td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"> {{ salesContact?.currency?.symbol }} {{ salesContact?.total_amount }}</td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-weight: bold; text-align: center;"></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Summary section -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <table style="width: 100%; border-collapse: collapse; font-size: 9px; margin-top: 5px;">
                        <tbody>

                          <tr>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px; text-align: center;"><strong>Total</strong></td>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px; text-align: center;"><strong>Amount in Words</strong></td>
                            <td colspan="6" style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 9px;">
                              <strong>{{ convertNumberToWords(salesContact?.total_amount) }} ONLY</strong>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px; text-align: center;"><strong>{{ formattedAdvancePayment }} Advance at Now</strong></td>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px;"></td>
                            <td colspan="6" style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 9px;">
                              <strong>{{ salesContact?.currency.symbol }} {{ formatNumber(salesContact?.advance_payment_amount) }}</strong>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px;"></td>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px; text-align: center;"><strong>Amount in Words</strong></td>
                            <td colspan="6" style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 9px;">
                              <strong>{{ convertNumberToWords(salesContact?.advance_payment_amount) }}</strong>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px; text-align: center;"><strong>{{ formattedBalancePayment }} Balance will be paid Before Shipment</strong></td>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px;"></td>
                            <td colspan="6" style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 9px;">
                              <strong>{{ salesContact?.currency?.symbol }} {{ formatNumber(salesContact?.before_shipment_payment_amount) }}</strong>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px;"></td>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px; text-align: center;"><strong>Amount in Words</strong></td>
                            <td colspan="6" style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 9px;">
                              <strong>{{ convertNumberToWords(salesContact?.before_shipment_payment_amount) }}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Shipment Terms -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <table style="width: 100%; border-collapse: collapse; margin-top: 5px;">
                        <thead>
                          <tr>
                            <th colspan="6" style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 9px; background-color: #ffffff;"><strong>CONDITION OF SHIPMENT:</strong></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>FROM</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.shipment_from }}</td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>TO</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.shipment_to }}</td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>PAYMENT TERMS</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.payment_term.name }}</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>SHIPMENT MODE</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.shipping_method.name }}</td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>INCOTERM</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.incoterm.name }}</td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>DATE OF EXPIRY</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>{{ formattedDate(salesContact?.expiry_date) }}</strong></td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>INSPECTION CERTIFICATE BY</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">ANOOSHA</td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>SHORT/EXCESS SHIPMENT</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">SHORT SHIPMENT NOT ALLOWED</td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>PARTIAL SHIPMENT</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.partial_shipment == 'not_allowed' ? 'Not Allowed' : 'Allowed' }}</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>PORT OF LOADING</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.loading_port.name }}</td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>PORT OF DESTINATION</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.discharge_port.name }}</td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>EARLY SHIPMENT</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px">{{ salesContact?.early_shipment == 'not_allowed' ? 'Not Allowed' : 'Allowed' }}</td>
                          </tr>
                          <tr>
                            <td colspan="4" style="border: 1px solid #000;"></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"><strong>TRANSHIPMENT</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; font-size: 9px"> {{ salesContact?.transhipment_shipment == 'not_allowed' ? 'Not Allowed' : 'Allowed' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Additional Condition -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <table style="width: 100%; border-collapse: collapse; margin-top: 5px;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 9px; background-color: #ffffff;"><strong>ADDITIONAL CONDITION:</strong></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 9px; min-height: 80px; vertical-align: top; white-space: pre-wrap; word-wrap: break-word;">
                              {{ salesContact?.additional_condition }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Signatures -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div style="margin-top: 10px;">
                        <v-row>
                          <v-col cols="6" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">SEAL & SIGNATURE OF THE SUPPLIER / BENEFICIARY</div>
                            </div>
                          </v-col>
                          <v-col cols="6" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">SEAL & SIGNATURE OF THE BUYER</div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <!-- <img v-if="salesContact?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${salesContact?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;"> -->
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" class="d-print-none mt-4 ">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import convertNumberToWords from "@/plugins/numberToWord";
import formattedDate from "@/plugins/dateFormatter";

const route = useRoute();
const router = useRouter();
const store = useStore();

const id = route.params.id;
const salesContact = ref(null);
const invoiceHeader = ref(true);
const pagePadding = ref(0);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

const formattedAdvancePayment = computed(() => {
  if (!salesContact.value) return '';
  const value = salesContact.value.advance_payment_value || 0;
  const type = salesContact.value.advance_payment_type;

  if (type === 'percentage' || type === 'percent') {
    return `${value}%`;
  } else if (type === 'flat') {
    return `${value}`;
  } else {
    return `${value} ${type}`;
  }
});

const formattedBalancePayment = computed(() => {
  if (!salesContact.value) return '';
  const value = salesContact.value.before_shipment_payment_value || 0;
  const type = salesContact.value.before_shipment_payment_type;

  if (type === 'percentage' || type === 'percent') {
    return `${value}%`;
  } else if (type === 'flat') {
    return `${value}`;
  } else {
    return `${value} ${type}`;
  }
});

const formatNumber = (val) => {
  if (val == null || val === "") return "";
  return Number(val).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Master Sales Contract</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          margin: ${pagePadding.value}px 0;
        } 
  
        html, body {  
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }
  
        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
        .details-table {
          padding: 0px 25px;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
        
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 9px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 9px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 9px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }
  
        th { 
          background: #e0e0e0; 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
          padding: 0px 30px;
          justify-content:space-between;
        }
  
        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 12px 6px;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        /* Prevent sections from breaking across pages */
        div[style*="margin-top"], div[style*="padding"] {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 9px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }
  
        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }
  
        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 9px;
        }
  
        .invoice-container {
          display: flex;
          flex-direction: column;
        }
  
        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
          
        .company-info {
          flex: 1;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left; 0;
          bottom: 15px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
  
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        
        ${printContent}
        
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(async () => { 
  try {
    const res = await store.dispatch("getMasterSalesContact", id);
    
    if (res?.data?.success) {
      salesContact.value = res.data.data;
      console.log("Master Sales Contact Data:", salesContact.value);
    } else {
      console.error("API returned unsuccessful response:", res);
    }
  } catch (error) {
    console.error("Error fetching sales contact:", error);
  }
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 9px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
